module.exports = __webpack_public_path__ + "static/media/tlsdiff.9bc7e01d.png";